var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeaker = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 3.8125C11.0831 4.92374 11.0831 7.07622 10.25 8.18746",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.125 1.625C14.6175 4.00498 14.6325 8.01057 12.125 10.3749",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.84933V4.14998C1.5 3.79124 1.78 3.49999 2.12499 3.49999H4.36623C4.44893 3.49969 4.53073 3.48265 4.60667 3.44989C4.68261 3.41713 4.75113 3.36933 4.8081 3.30936L6.68308 1.19188C7.07683 0.781885 7.74995 1.07251 7.74995 1.65188V10.3481C7.74995 10.9318 7.06871 11.2199 6.67746 10.8018L4.80872 8.6962C4.75159 8.63453 4.68238 8.58528 4.60539 8.55151C4.52841 8.51775 4.44529 8.5002 4.36123 8.49995H2.12499C1.78 8.49995 1.5 8.2087 1.5 7.84933Z",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeaker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speaker.cf284398.svg";
export { ForwardRef as ReactComponent };